import { IRatingScaleProps } from './IRatingScaleProps';
import { IOption } from '@srm/ui/types/IOption';
import { RatingScaleSelect } from './RatingScaleSelect';

const scaleOptions: IOption[] = [
    { value: 5.0, label: '5' },
    { value: 4.0, label: '4' },
    { value: 3.0, label: '3' },
    { value: 2.0, label: '2' },
];

/** ПИР и СМР (5,4,3,2) */
export const RatingScalePirSmr = (props: IRatingScaleProps) => (
    <RatingScaleSelect {...props} scaleClassName="offer-crit-rating-scale-pir-smr" options={scaleOptions} />
);
